import type { ColorShades } from '../utils';

const ash: ColorShades = {
  50: '#ececec',
  100: '#c3c3c3',
  200: '#a6a6a6',
  300: '#7d7d7d',
  400: '#646464',
  500: '#3d3d3d',
  600: '#383838',
  700: '#2b2b2b',
  800: '#222222',
  900: '#1a1a1a',
};

const snow: ColorShades = {
  50: '#fdfdfd',
  100: '#f7f7f7',
  200: '#f4f4f4',
  300: '#eeeeee',
  400: '#ebebeb',
  500: '#e6e6e6',
  600: '#d1d1d1',
  700: '#a3a3a3',
  800: '#7f7f7f',
  900: '#616161',
};

const sharp: ColorShades = {
  50: '#ffffff',
  100: '#ffffff',
  200: '#ffffff',
  300: '#ffffff',
  400: '#ffffff',
  500: '#000000',
  600: '#000000',
  700: '#000000',
  800: '#000000',
  900: '#000000',
};

const laurel: ColorShades = {
  50: '#ecf8ed',
  100: '#c3e8c7',
  200: '#a7ddac',
  300: '#7ece86',
  400: '#65c56f',
  500: '#3fb64b',
  600: '#39a644',
  700: '#2d8135',
  800: '#236429',
  900: '#1a4c20',
};
const denim: ColorShades = {
  50: '#e6f2f9',
  100: '#b1d6ed',
  200: '#8bc3e5',
  300: '#55a7d9',
  400: '#3596d1',
  500: '#027cc6',
  600: '#0271b4',
  700: '#01588d',
  800: '#01446d',
  900: '#013453',
};
const sand: ColorShades = {
  50: '#fff8f1',
  100: '#ffe8d4',
  200: '#ffddbf',
  300: '#ffcea1',
  400: '#ffc58f',
  500: '#ffb673',
  600: '#e8a669',
  700: '#b58152',
  800: '#8c643f',
  900: '#6b4c30',
};
const coral: ColorShades = {
  50: '#fdf0ef',
  100: '#f9d0ce',
  200: '#f7bab6',
  300: '#f39a95',
  400: '#f18681',
  500: '#ed6861',
  600: '#d85f58',
  700: '#a84a45',
  800: '#823935',
  900: '#642c29',
};

const turquoise: ColorShades = {
  50: '#e7f5f7',
  100: '#b3e0e5',
  200: '#8fd1d8',
  300: '#5cbbc7',
  400: '#3caebc',
  500: '#0b9aab',
  600: '#0a8c9c',
  700: '#086d79',
  800: '#06555e',
  900: '#054148',
};

const darkBlue: ColorShades = {
  50: '#ebeef1',
  100: '#c1c9d3',
  200: '#a3afbe',
  300: '#788aa1',
  400: '#5e738e',
  500: '#365072',
  600: '#314968',
  700: '#263951',
  800: '#1e2c3f',
  900: '#172230',
};

const petrol: ColorShades = {
  50: '#ecf0f2',
  100: '#c5d1d7',
  200: '#a9bac3',
  300: '#829ba8',
  400: '#698897',
  500: '#446a7d',
  600: '#3e6072',
  700: '#304b59',
  800: '#253a45',
  900: '#1d2d35',
};

const olive: ColorShades = {
  50: '#f0f3f3',
  100: '#d1dbd8',
  200: '#bac9c6',
  300: '#9bb1ab',
  400: '#87a19b',
  500: '#698a82',
  600: '#607e76',
  700: '#4b625c',
  800: '#3a4c48',
  900: '#2c3a37',
};

const eucalyptus: ColorShades = {
  50: '#f4f8f8',
  100: '#dde8ea',
  200: '#ccdde0',
  300: '#b5ced1',
  400: '#a7c5c9',
  500: '#91b6bb',
  600: '#84a6aa',
  700: '#678185',
  800: '#506467',
  900: '#3d4c4f',
};

const coolGrey: ColorShades = {
  50: '#fbfbfb',
  100: '#f3f3f2',
  200: '#eeedec',
  300: '#e6e5e4',
  400: '#e1e0de',
  500: '#d9d8d6',
  600: '#c5c5c3',
  700: '#9a9998',
  800: '#777776',
  900: '#5b5b5a',
};

const grey: ColorShades = {
  50: '#fdfdfd',
  100: '#faf9f9',
  200: '#f7f7f7',
  300: '#f4f3f3',
  400: '#f1f1f1',
  500: '#eeeded',
  600: '#d9d8d8',
  700: '#a9a8a8',
  800: '#838282',
  900: '#646464',
};

const orange: ColorShades = {
  50: '#fff0ea',
  100: '#ffd2be',
  200: '#ffbc9e',
  300: '#ff9d72',
  400: '#ff8a57',
  500: '#ff6d2d',
  600: '#e86329',
  700: '#b54d20',
  800: '#8c3c19',
  900: '#6b2e13',
};

const rose: ColorShades = {
  50: '#fff2ef',
  100: '#ffd5ce',
  200: '#ffc1b7',
  300: '#ffa596',
  400: '#ff9481',
  500: '#ff7962',
  600: '#e86e59',
  700: '#b55646',
  800: '#8c4336',
  900: '#6b3329',
};

const biscuit: ColorShades = {
  50: '#fffaf5',
  100: '#ffefe0',
  200: '#ffe7d1',
  300: '#ffdbbc',
  400: '#ffd5af',
  500: '#ffca9b',
  600: '#e8b88d',
  700: '#b58f6e',
  800: '#8c6f55',
  900: '#6b5541',
};

export const tbColors = {
  primary: ash,
  secondary: snow,
  sharp,
  semantic: {
    laurel,
    denim,
    sand,
    coral,
  },
  brand: {
    turquoise,
    coral,
    darkBlue,
    petrol,
    olive,
    eucalyptus,
    coolGrey,
    grey,
    orange,
    rose,
    sand,
    biscuit,
  },
  all: {
    ash,
    snow,
    sharp,
    laurel,
    denim,
    sand,
    coral,
    turquoise,
    darkBlue,
    petrol,
    olive,
    eucalyptus,
    coolGrey,
    grey,
    orange,
    rose,
    biscuit,
  },
} as const;

export type ColorName = keyof typeof tbColors;
export type ColorShade = keyof (typeof tbColors)[keyof typeof tbColors];
